var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pointer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pointer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7110001,15.5010001 C20.1020001,15.8920001 20.1020001,16.5250001 19.7110001,16.9150001 L16.9160001,19.7100001 C16.5250001,20.1010001 15.8920001,20.1010001 15.5020001,19.7100001 L12.0000001,16.2080001 L9.90400004,18.3040001 C9.37800004,18.8300001 8.48300004,18.6180001 8.24800003,17.9130001 L4.04800002,5.31200002 C3.78700002,4.53100002 4.53100002,3.78700002 5.31300002,4.04800002 L17.9140001,8.24800003 C18.6190001,8.48300004 18.8310001,9.37800004 18.3050001,9.90400004 L16.2090001,11.999 L19.7110001,15.5010001 Z",
    stroke: "#BABABA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/Selection.4e4701f2a7dea9b04ac6f171250a07fb.svg";
export { ForwardRef as ReactComponent };